module.exports = __webpack_public_path__ + "static/media/truck8.af0dfe49.jpg";